import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './AccessDeniedCard.scss';
import { Icon } from 'design-system-web';

export function AccessDeniedCard() {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.emptyBlock}>
        <div className={styles.lockCircle}>
          <Icon
            name="lock-alt"
            type="far"
            className={styles.lockIcon}
          />
        </div>
        <p className={styles.title}>
          {t('shared.integrations.bePrism.accessRequired')}
        </p>
        <p className={styles.subTitle}>
          {t('shared.integrations.bePrism.noBuildingAccess')}
        </p>
      </div>
    </div>
  );
}
